// extracted by mini-css-extract-plugin
module.exports = {"component":"person_component__20sw8","isCustomColor":"person_isCustomColor__tGDMG","name":"person_name__cyXD0","position":"person_position__3Bqb_","avatar":"person_avatar__xz3aY"};